module.exports = __webpack_public_path__ + "static/media/target.2d09a67e.png";